export default [
  {
    id: 1,
    title: 'Select Model'
  },
  {
    id: 2,
    title: 'Model Info'
  },
  {
    id: 3,
    title: 'PoC'
  },
  {
    id: 4,
    title: 'Billing'
  },
  {
    id: 5,
    title: 'Lab Info'
  },
  {
    id: 6,
    title: 'Documents'
  }
];



// WEBPACK FOOTER //
// ./src/components/Stepper/ecoSteps.js